import React from "react";
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { TextBox, Button } from "devextreme-react";
import { Icon } from 'rsuite';

import ReactAI from "react-appinsights";
import createHistory from "history/createBrowserHistory";
import validacion from "../../../helpers/validaciones";
import styles from "../../../styles/stylesgenerales";
import logo from "../../../images/logoachs.png";
// import Campanias from "../../Acceso/Campanias/view";
import LoginBackground from './background';
import { paths } from "../../../config/routes";
import {
  setDataLogin,
  doLogin,
  setMessageLogin,
  disableButton,
  doValidation,
  showPassInput,
  accountIsActive,
  doResendActivation,
} from "./actions";
import { replaceFromTo } from "../../../helpers/strings";

import { cleanRegisterStep } from "../Registro/actions";
import LoadingOverlay from "../../Shared/LoadingOverlay";
import { isIframe } from "helpers/isIframe";

const history = createHistory();
ReactAI.init(
  { instrumentationKey: "8a1c69be-30ce-4375-9d1b-3868061eb863" },
  history
);

const isAbleLoginAv1 = process.env.REACT_APP_IS_ABLE_LOGIN_AV1 === 'true' || isIframe ? true : false;
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.passRef = React.createRef();
    this.state = {
      resendEmail: false,
      email: "",
    };
    if(!isAbleLoginAv1) window.location.href = '/achs';
  }

  componentDidMount = () => {
    this.resetLoginview();
    if (document.getElementById("lt-app-container-publico-home")) {
      document.getElementById("lt-app-container-publico-home").remove();
    }
    if (document.getElementById("lt-app-container-iniciar-chat-publico-home")) {
      document
        .getElementById("lt-app-container-iniciar-chat-publico-home")
        .remove();
    }
    if (document.getElementById("lt-app-container-chat-privado-achs-virtual")) {
      document
        .getElementById("lt-app-container-chat-privado-achs-virtual")
        .remove();
    }
    if (document.getElementById("lt-app-frame-chat-privado-achs-virtual")) {
      document
        .getElementById("lt-app-frame-chat-privado-achs-virtual")
        .remove();
    }
  };

  componentDidUpdate = (prevProps) => {
    if (!prevProps.showPassInput && this.props.showPassInput) {
      this.passRef.focus();
    }
  };

  handleLoginSteps = () => {
    if (!this.props.data.Username) {
      this.props.dispatch(setMessageLogin("Ingresa tu rut o email"));
      return;
    }
    // if (this.props.showPassInput) {
    if (!this.props.data.Password) {
      this.props.dispatch(setMessageLogin("Ingresa tu contraseña"));
      return;
    }
    this.logIn();
    // }
    // } else {
    //   this.props.dispatch(doValidation(this.props.data));
    // }
  };

  hideText = (text) => {
    let hiddenText;
    if (text.indexOf("@") !== -1) {
      let index = text.indexOf("@");
      hiddenText = replaceFromTo(
        text,
        Math.round(index / 2) - 1,
        index - 1,
        "\u25CF"
      );
    } else if (/\d/.test(text)) {
      hiddenText = replaceFromTo(text, 7, text.length, "\u25CF");
    }
    return hiddenText;
  };

  handleResendActivation = () => {
    this.props.dispatch(
      doResendActivation(this.props.activeUserData, this.props.data)
    );
    if (this.props.activeUserData.SignInNameType === "emailAddress") {
      this.setState({
        ...this.state,
        resendEmail: true,
        email: this.hideText(this.props.activeUserData.SignInNameValue),
      });
    } else if (this.props.data.AuthType === "EMAIL") {
      this.state.email = this.hideText();
      this.setState({
        ...this.state,
        resendEmail: true,
        email: this.hideText(this.props.data.Username),
      });
    }
  };

  resetLoginview = () => {
    this.props.dispatch(showPassInput(false));
    this.props.dispatch(accountIsActive(true));
    this.props.dispatch(disableButton(true));
    this.props.dispatch(setMessageLogin());
    this.props.dispatch(
      setDataLogin({
        Username: null,
        Password: null,
        AuthType: null,
      })
    );
    this.setState({
      resendEmail: false,
      email: "",
    });
  };

  handleChange = (e) => {
    const ident = typeof e === "object" ? e.element.id : "";
    const { data } = this.props;
    let time = 1500;
    switch (ident) {
      case "email": {
        let errorEmailRut = "";
        let isValid = true;
        let validacionTpo = "";

        if (this.props.showPassInput) {
          if (e.value === "") {
            this.resetLoginview();
          }
          return;
        }
        if (e.value === "") {
          data.Password = "";
        }

        if (!this.props.message && this.props.message !== "")
          this.props.dispatch(setMessageLogin());

        e.value = e.value
          .replace(/\s+/g, " ")
          .replace(/^\s+|\s+$/, "")
          .trim();
        const isRut = validacion.cleanRut(e.value);

        if (validacion.validarEmail(e.value)) {
          validacionTpo = "EMAIL";
        } else if (e.value.length > 6 && validacion.validateRut(isRut)) {
          validacionTpo = "RUN";
        } else if (e.value === "") {
          time = 200;
          this.resetLoginview();
        } else {
          errorEmailRut = "Rut o correo electrónico es inválido";
          isValid = false;
        }

        let { value } = e;
        if (validacionTpo === "RUN") {
          value = validacion.formatRut(e.value, {
            showDots: false,
            showHyphen: true,
          });
        }

        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          e.component.option({
            validationError: { message: errorEmailRut },
            isValid,
          });
        }, time);

        data.AuthType = validacionTpo;
        data.Username = value;
        break;
      }
      case "pass": {
        data.Password = e.value;

        if (e.value === "") {
          e.component.option({
            validationError: { message: "Contraseña no puede estar vacía" },
            isValid: false,
          });
          break;
        }

        e.component.option({
          validationError: { message: "Contraseña no puede estar vacía" },
          isValid: true,
        });

        if (!this.props.message && this.props.message !== "")
          this.props.dispatch(setMessageLogin());
        break;
      }

      default:
        break;
    }
    this.props.dispatch(setDataLogin(data));
  };

  logIn() {
    this.props.dispatch(doLogin(this.props.data, this.props.isAccountTemp));
  }

  userRegitserView = () => {
    this.resetLoginview();
    this.props.dispatch(cleanRegisterStep());
    this.props.dispatch(push(paths.registro));
  };

  passwordRecoveryView = () => {
    this.props.dispatch(push(paths.recuperarContraseña));
  };

  render() {
    const typeBoton =
      this.props.data.Username && this.props.data.Password
        ? "default"
        : "default";

    if(!isAbleLoginAv1) return <></>
    return (
      <div className="zero row">
        <div
          className="zero d-none d-md-block col-xs-8 col-sm-8 col-md-6 col-lg-7 col-xl-8"
          style={{ backgroundColor: "black", height: "auto" }}
        >
          {/* <Campanias /> */}
          <LoginBackground />
        </div>
        <div
          className="zero col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-4"
          style={{
            overflowY: "auto",
            position: "absolute",
            right: 0,
            height: "100%",
          }}
        >
          <center>
            <div className="zero container-fluid">
                <div className="headerLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <img
                    src={logo}
                    alt=""
                    style={styles.logoLogin}
                    height="50px"
                  />
                </div>

              <div className="acceso row">
                {this.props.isLoading && (
                  <LoadingOverlay style={{ height: 660 }} />
                )}
                <div className="tituloLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <h3>Iniciar sesión</h3>
                </div>
                {!this.props.isAccountActive && (
                  <div className="componentesLogin justify-content-md-center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <h2>
                      <p style={{ color: "#E62A3B", fontWeight: "bolder" }} className="danger">
                          {this.state.resendEmail
                          ? `Se ha enviado el correo de activación a ${this.state.email}`
                          : " Tu cuenta aún no se encuentra activada."}
                      </p>
                    </h2>
                  </div>
                )}
                <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <h3>
                    {" "}
                    <p className="text-left success">Usuario</p>
                  </h3>
                  <TextBox
                    id="email"
                    onEnterKey={
                      this.props.data.Username !== "" &&
                      this.props.data.Username != null
                        ? this.handleLoginSteps
                        : null
                    }
                    className={
                      this.props.showPassInput ? "color-input" : "input"
                    }
                    inputAttr={{placeholder: 'Rut o dirección de correo electrónico'}}
                    onValueChanged={this.handleChange}
                    valueChangeEvent={
                      this.props.showPassInput ? "input" : "input"
                    }
                    value={this.props.data.Username}
                    activeStateEnabled={!this.props.showPassInput}
                    showClearButton={this.props.showPassInput}
                  />
                  <h4>
                    <p className="text-left" style={{ marginTop: 11, fontSize: 12 }}>
                      Sin puntos y con guión{" "}
                    </p>
                  </h4>
                </div>
                {/* {this.props.showPassInput && this.props.isAccountActive */}
                {true && (
                  <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <h3>
                      <p className="text-left success">Contraseña</p>
                    </h3>
                    <TextBox
                      id="pass"
                      ref={(ref) => {
                        if (ref != null) this.passRef = ref.instance;
                      }}
                      onEnterKey={() => {
                        if (
                          this.props.data.Password !== "" &&
                          this.props.data.Password != null
                        )
                          this.handleLoginSteps();
                      }}
                      inputAttr={{placeholder: 'Contraseña'}}
                      mode="password"
                      onValueChanged={this.handleChange}
                      value={this.props.data.Password}
                      valueChangeEvent="input"
                    />
                  </div>
                )}
                <div className="componentesLogin justify-content-md-center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <h3>
                    {this.props.message == null ? (
                      ""
                    ) : (
                      <p style={{ color: "#E62A3B" }} className="danger">
                        {" "}
                        {this.props.message}{" "}
                      </p>
                    )}
                  </h3>
                </div>

                <div class="representante-legal-alert alert alert-warning alert-dismissible" role="alert" style={{ display: 'flex' }}>
                  <Icon icon='exclamation-circle' size="3x" style={{ color: '#F7E102' }}/>
                  <p style={{ textAlign: 'left', fontSize: '.9em' }}>
                    <strong>Recuerda</strong> que puedes tener diferentes contraseñas para las
                    distintas plataformas de la ACHS. Si no la recuerdas, puedes
                    recuperar tu contraseña haciendo&nbsp;
                    <Link to="/recuperarContrase%C3%B1a"><strong>click aquí</strong></Link>
                  </p>
                </div>

                <div className="componentesLogin justify-content-md-center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  {this.props.isAccountActive ? (
                    <Button
                      style={styles.fullWidth}
                      text="Iniciar sesión"
                      type={typeBoton}
                      // disabled={(validacion.)}
                      onClick={this.handleLoginSteps}
                    />
                  ) : (
                    <Button
                      style={styles.fullWidth}
                      text="Reenviar correo de activación"
                      type="success"
                      onClick={this.handleResendActivation}
                    />
                  )}
                </div>

                {/* <div className="contrasena justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <a
                    onClick={this.passwordRecoveryView}
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                  >
                    <h5> ¿Olvidaste tu contraseña? </h5>
                  </a>
                </div> */}

                <div className="registro justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="contrasena justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <a
                      onClick={this.passwordRecoveryView}
                    >
                      <span>Activa tu cuenta o recupera tu contraseña</span>
                    </a>
                  </div>
                  {/* <Button
                    style={styles.fullWidth}
                    text="Problemas de cuenta o contraseña"
                    type="success"
                    onClick={() => this.passwordRecoveryView()}
                  /> */}
                  {/* <span style={{ marginTop: "10px" }}>
                    <hr
                      style={{ cursor: "pointer", textDecoration: "underline" }}
                    />
                  </span> */}
                </div>
                <div className="componentesLogin justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <Button
                    style={styles.fullWidth}
                    text="Registrar Usuario"
                    type="success"
                    onClick={() => this.userRegitserView()}
                  />
                </div>
                <div className="registro justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="contrasena justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <a
                      href={`https://www.achs.cl/portal/Paginas/Soporte_Achs_Virtual.aspx`}
                    >
                      <span>Encuentra material de soporte aquí</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="d-sm-block d-lg-none dx-access-browsers-info">
              <span>ACHS Virtual está optimizado para ser visto</span>
              <br />
              <span>En un computador de escritorio</span>
              </div>
              <div className="d-none d-lg-block dx-access-browsers-info">
                  <span>ACHS Virtual está optimizado para las últimas versiones de</span>
                  <br />
                  <span>Google Chrome, Mozilla Firefox y Microsoft Edge</span>
              </div>
              {/* <div className="dx-access-browsers-info">
                <span>ACHS Virtual está optimizado para las últimas versiones de</span>
                <br />
                <span>Google Chrome, Mozilla Firefox y Microsoft Edge</span>
              </div> */}
            </div>
          </center>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.login.data,
  message: state.login.message,
  isLoading: state.global.isLoading,
  showPassInput: state.login.showPassInput,
  isAccountTemp: state.login.isAccountTemp,
  disableButton: state.login.disableButton,
  isAccountActive: state.login.isAccountActive,
  activeUserData: state.login.activeUserData,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
ReactAI.withTracking(Login);
